import { Formik } from 'formik'
import { ReactElement, useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { v4 } from 'uuid'
import moment from 'moment'
import { accountsState } from '../states/accounts-state'
import { IAccount } from '../types/types'
import FormControl from '../components/form-control/form-control'
import Label from '../components/label/label'
import LabelText from '../components/label/label-text'
import { getHeaders } from '../utils/get-headers'

interface FormErrors {
  email?: string
}

const INITIAL_VALUES: Partial<IAccount> = {
  id: v4(),
  name: '',
  openedAt: moment().toDate(),
}

const AccountForm = (): ReactElement => {
  const setAccount = useSetRecoilState(accountsState)

  const onSubmit = useCallback(async (values, { setSubmitting }) => {
    const { name } = values
    const { data } = await axios.post(
      getServerHost('account'),
      {
        name,
      },
      { headers: getHeaders() },
    )

    if (data.account) {
      // Log user
      setAccount((prevState) => [...prevState, data.account])
    }
  }, [])

  return (
    <Formik initialValues={INITIAL_VALUES} onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        // @ts-ignore
        <form onSubmit={handleSubmit}>
          <h2 className="font-bold">Create New Account</h2>
          <FormControl>
            <Label>
              <LabelText>Account Name</LabelText>
            </Label>
            <input
              type="text"
              name="name"
              className="input input-bordered w-full min-w-8 mb-4"
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="name"
              value={values.name}
            />
          </FormControl>
          <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
            Submit
          </button>
        </form>
      )}
    </Formik>
  )
}

export default AccountForm